import { IconProps } from "./types";

export const PlusIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 14.8223C7.6 14.8223 7.33333 14.5556 7.33333 14.1556V9.48893H2.66667C2.26667 9.48893 2 9.22227 2 8.82227C2 8.42227 2.26667 8.1556 2.66667 8.1556H7.33333V3.48893C7.33333 3.08893 7.6 2.82227 8 2.82227C8.4 2.82227 8.66667 3.08893 8.66667 3.48893V8.1556H13.3333C13.7333 8.1556 14 8.42227 14 8.82227C14 9.22227 13.7333 9.48893 13.3333 9.48893H8.66667V14.1556C8.66667 14.5556 8.4 14.8223 8 14.8223Z"
        fill={fillColor ?? "white"}
      />
    </svg>
  );
};
